"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NexusPatch = void 0;
const nexus_node_texture_1 = require("./nexus-node-texture");
class NexusPatch {
    constructor(id, node, lastTriangle, texture) {
        this.id = id;
        this.node = node;
        this.lastTriangle = lastTriangle;
        if (typeof (texture) === 'number') {
            this.texture = new nexus_node_texture_1.NexusNodeTexture(texture);
        }
        else if (!texture) {
            this.texture = nexus_node_texture_1.NexusNodeTexture.EMPTY_TEXTURE;
        }
        else {
            this.texture = texture;
        }
    }
    withTexture(texture) {
        return new NexusPatch(this.id, this.node, this.lastTriangle, texture);
    }
}
exports.NexusPatch = NexusPatch;
